module.exports = __webpack_public_path__ + "layout_com5.jpg?6c4ef66b74ec206132119a25e37a8684";


//////////////////
// WEBPACK FOOTER
// ./src/assets/layouts/layout_com5.jpg
// module id = 85
// module chunks = 0